export const EmptyComponent = () => null;